// Shown only when the Super Admin API is not deployed yet (404 or network).
// Template counts stay fixed. Sign-ins and time follow the period.

const NOW = Date.parse('2026-10-30T14:46:00Z')
const SCALE = { 1: 0.12, 7: 0.36, 30: 1, 90: 2.15 }

export const COMPANIES = [
    { CompanyId: 1, CompanyName: 'Northline Facilities', Plan: 'Enterprise', Templates: 186, Members: 42, OwnerName: 'Priya Shah', OwnerEmail: 'priya.shah@example.com', OwnerPhone: '+91 98450 11220', JoinedOn: '2019-04-12', SignIns: 820, Status: 'Active' },
    { CompanyId: 2, CompanyName: 'Harbor & Co Safety', Plan: 'Growth', Templates: 96, Members: 18, OwnerName: 'James Okonkwo', OwnerEmail: 'james.okonkwo@example.com', OwnerPhone: '+1 202 555 0142', JoinedOn: '2021-11-03', SignIns: 410, Status: 'Active' },
    { CompanyId: 3, CompanyName: 'Sample Hospitality', Plan: 'Growth', Templates: 74, Members: 11, OwnerName: 'Elena Vargas', OwnerEmail: 'elena.vargas@example.com', OwnerPhone: '+1 415 555 0190', JoinedOn: '2023-02-18', SignIns: 266, Status: 'Active' },
    { CompanyId: 4, CompanyName: 'Pinnacle Foods', Plan: 'Starter', Templates: 41, Members: 7, OwnerName: 'Ben Carter', OwnerEmail: 'ben.carter@example.com', OwnerPhone: '+1 646 555 0177', JoinedOn: '2024-06-09', SignIns: 150, Status: 'Active' },
    { CompanyId: 5, CompanyName: 'Westbrook Schools', Plan: 'Starter', Templates: 28, Members: 9, OwnerName: 'Claire Hughes', OwnerEmail: 'claire.hughes@example.com', OwnerPhone: null, JoinedOn: '2024-09-21', SignIns: 98, Status: 'Active' },
    { CompanyId: 6, CompanyName: 'Hartwell Energy', Plan: 'Trial', Templates: 12, Members: 3, OwnerName: 'Irene Walsh', OwnerEmail: 'irene.walsh@example.com', OwnerPhone: '+44 20 7946 0991', JoinedOn: '2025-08-14', SignIns: 44, Status: 'Trial' },
    { CompanyId: 7, CompanyName: 'Sample Clinics', Plan: 'Free', Templates: 6, Members: 2, OwnerName: 'Riley Nguyen', OwnerEmail: 'riley.nguyen@example.com', OwnerPhone: '+1 646 555 0171', JoinedOn: '2026-01-19', SignIns: 22, Status: 'Free' },
    { CompanyId: 8, CompanyName: 'Nova Freight', Plan: 'Growth', Templates: 14, Members: 6, OwnerName: 'Lars Nielsen', OwnerEmail: 'lars.nielsen@example.com', OwnerPhone: '+49 30 555 0188', JoinedOn: '2026-10-28', SignIns: 40, Status: 'Active' },
]

export const USERS = [
    { UserId: 1, Name: 'Priya Shah', Email: 'priya.shah@example.com', Phone: '+91 98450 11220', CompanyName: 'Northline Facilities', Minutes: 2772, Sessions: 128 },
    { UserId: 2, Name: 'James Okonkwo', Email: 'james.okonkwo@example.com', Phone: '+1 202 555 0142', CompanyName: 'Harbor & Co Safety', Minutes: 1840, Sessions: 96 },
    { UserId: 3, Name: 'Elena Vargas', Email: 'elena.vargas@example.com', Phone: '+1 415 555 0190', CompanyName: 'Sample Hospitality', Minutes: 1320, Sessions: 74 },
    { UserId: 4, Name: 'Avery Chen', Email: 'avery.chen@example.com', Phone: '+1 202 555 0148', CompanyName: 'Northline Facilities', Minutes: 980, Sessions: 61 },
    { UserId: 5, Name: 'Lars Nielsen', Email: 'lars.nielsen@example.com', Phone: '+49 30 555 0188', CompanyName: 'Nova Freight', Minutes: 640, Sessions: 28 },
    { UserId: 6, Name: 'Ben Carter', Email: 'ben.carter@example.com', Phone: '+1 646 555 0177', CompanyName: 'Pinnacle Foods', Minutes: 410, Sessions: 19 },
]

const SIGNINS = [
    { UserId: 11, Name: 'Avery Chen', Email: 'avery.chen@example.com', Phone: '+1 202 555 0148', CompanyName: 'Northline Facilities', License: 'Paid', Templates: 12, Team: 8, Events: 3, Method: 'Google', Platform: 'Web', LastSignIn: '2026-10-30T14:22:00Z', RegisteredOn: '2024-03-02' },
    { UserId: 12, Name: 'Priya Shah', Email: 'priya.shah@example.com', Phone: '+91 98450 11220', CompanyName: 'Sample Hospitality', License: 'Free', Templates: 4, Team: 2, Events: 2, Method: 'Email', Platform: 'Mobile', LastSignIn: '2026-10-30T13:16:00Z', RegisteredOn: '2025-06-11' },
    { UserId: 13, Name: 'Lars Nielsen', Email: 'lars.nielsen@example.com', Phone: '+49 30 555 0188', CompanyName: 'Nova Freight', License: 'Free', Templates: 5, Team: 4, Events: 1, Method: 'Google', Platform: 'Web', LastSignIn: '2026-10-30T12:10:00Z', RegisteredOn: '2026-08-16' },
    { UserId: 14, Name: 'Chris Daley', Email: 'chris.daley@example.com', Phone: null, CompanyName: 'Ridgeway Construction', License: 'Free', Templates: 4, Team: 3, Events: 2, Method: 'Google', Platform: 'Web', LastSignIn: '2026-10-30T11:40:00Z', RegisteredOn: '2026-10-28' },
    { UserId: 15, Name: 'Riley Nguyen', Email: 'riley.nguyen@example.com', Phone: '+1 646 555 0171', CompanyName: 'Sample Clinics', License: 'Free', Templates: 1, Team: 1, Events: 1, Method: 'Email', Platform: 'Mobile', LastSignIn: '2026-10-30T10:16:00Z', RegisteredOn: '2026-10-29' },
    { UserId: 16, Name: 'Sam Rivera', Email: 'sam.rivera@example.com', Phone: '+1 202 555 0166', CompanyName: 'Sample Inspections', License: 'Free', Templates: 3, Team: 1, Events: 1, Method: 'Google', Platform: 'Web', LastSignIn: '2026-10-29T10:46:00Z', RegisteredOn: '2026-04-02' },
    { UserId: 17, Name: 'Noor Rahman', Email: 'noor.rahman@example.com', Phone: null, CompanyName: 'Sample Catering', License: 'Free', Templates: 1, Team: 1, Events: 0, Method: null, Platform: null, LastSignIn: null, RegisteredOn: '2026-10-30' },
]

const WATCH = [
    { UserId: 21, Name: 'Daniel Cho', Email: 'daniel.cho@example.com', Phone: '+1 312 555 0194', CompanyName: 'Meridian Compliance', License: 'Free', Templates: 11, Team: 5, Breach: 'Both', LastSignIn: '2026-10-20T15:00:00Z', RegisteredOn: '2025-01-09' },
    { UserId: 12, Name: 'Priya Shah', Email: 'priya.shah@example.com', Phone: '+91 98450 11220', CompanyName: 'Sample Hospitality', License: 'Free', Templates: 4, Team: 2, Breach: 'Both', LastSignIn: '2026-10-30T13:16:00Z', RegisteredOn: '2025-06-11' },
    { UserId: 13, Name: 'Lars Nielsen', Email: 'lars.nielsen@example.com', Phone: '+49 30 555 0188', CompanyName: 'Nova Freight', License: 'Free', Templates: 5, Team: 4, Breach: 'Both', LastSignIn: '2026-10-30T12:10:00Z', RegisteredOn: '2026-08-16' },
    { UserId: 14, Name: 'Chris Daley', Email: 'chris.daley@example.com', Phone: null, CompanyName: 'Ridgeway Construction', License: 'Free', Templates: 4, Team: 3, Breach: 'Both', LastSignIn: '2026-10-30T11:40:00Z', RegisteredOn: '2026-10-28' },
    { UserId: 16, Name: 'Sam Rivera', Email: 'sam.rivera@example.com', Phone: '+1 202 555 0166', CompanyName: 'Sample Inspections', License: 'Free', Templates: 3, Team: 1, Breach: 'Templates', LastSignIn: '2026-10-29T10:46:00Z', RegisteredOn: '2026-04-02' },
    { UserId: 18, Name: 'Maya Iyer', Email: 'maya.iyer@example.com', Phone: '+91 98450 11880', CompanyName: 'Sample Kitchens', License: 'Free', Templates: 8, Team: 1, Breach: 'Templates', LastSignIn: '2026-10-18T12:00:00Z', RegisteredOn: '2025-11-02' },
    { UserId: 19, Name: 'Claire Hughes', Email: 'claire.hughes@example.com', Phone: null, CompanyName: 'Westbrook Schools', License: 'Free', Templates: 1, Team: 4, Breach: 'Team', LastSignIn: '2026-10-22T16:12:00Z', RegisteredOn: '2024-09-21' },
    { UserId: 20, Name: 'Morgan Patel', Email: 'morgan.patel@example.com', Phone: '+44 20 7946 0991', CompanyName: 'Sample Audit Co.', License: 'Free', Templates: 2, Team: 3, Breach: 'Team', LastSignIn: '2026-10-27T08:46:00Z', RegisteredOn: '2026-02-14' },
]

const scaleOf = periodDays => SCALE[periodDays] || 1

const scaled = (n, periodDays) => Math.max(0, Math.round(n * scaleOf(periodDays)))

const match = (row, search, fields) => {
    const q = String(search || '').trim().toLowerCase()
    if (!q) return true
    return fields.some(field => String(row[field] || '').toLowerCase().includes(q))
}

const pageOf = (rows, pageNumber, pageSize) => {
    const start = (pageNumber - 1) * pageSize
    return {
        Items: rows.slice(start, start + pageSize),
        TotalCount: rows.length,
    }
}

export const sampleOverview = periodDays => {
    const companies = COMPANIES.map(company => ({
        ...company,
        SignIns: scaled(company.SignIns, periodDays),
    })).sort((a, b) => b.Templates - a.Templates)
    const latest = [...COMPANIES].sort((a, b) => Date.parse(b.JoinedOn) - Date.parse(a.JoinedOn)).slice(0, 4)
    const users = USERS.map(user => ({
        ...user,
        Minutes: scaled(user.Minutes, periodDays),
        Sessions: scaled(user.Sessions, periodDays),
    })).sort((a, b) => b.Minutes - a.Minutes)
    return {
        PeriodDays: periodDays,
        CompanyCount: COMPANIES.length,
        TemplateCount: COMPANIES.reduce((sum, company) => sum + company.Templates, 0),
        LatestCompany: latest[0],
        TopUser: users[0],
        TemplateRanking: companies,
        LatestCompanies: latest,
        UsersByTime: users,
    }
}

export const sampleCompanies = ({ pageNumber, pageSize, search, status, sort, sortDir }) => {
    let rows = COMPANIES.filter(company => status === 'All' || company.Status === status || company.Plan === status)
    rows = rows.filter(company => match(company, search, ['CompanyName', 'OwnerName', 'OwnerEmail', 'Plan']))
    const dir = sortDir === 'asc' ? 1 : -1
    let key = 'Templates'
    if (sort === 'name') {
        key = 'CompanyName'
    } else if (sort === 'joined') {
        key = 'JoinedOn'
    }
    rows = [...rows].sort((a, b) => {
        if (key === 'CompanyName') return a.CompanyName.localeCompare(b.CompanyName) * dir
        if (key === 'JoinedOn') return (Date.parse(a.JoinedOn) - Date.parse(b.JoinedOn)) * dir
        return (a.Templates - b.Templates) * dir
    })
    return pageOf(rows, pageNumber, pageSize)
}

export const sampleSignIns = ({ periodDays, pageNumber, pageSize, search }) => {
    const windowMs = periodDays * 86400000
    const rows = SIGNINS.filter(user => {
        const registered = Date.parse(`${user.RegisteredOn}T12:00:00Z`)
        const signedIn = user.LastSignIn && NOW - Date.parse(user.LastSignIn) <= windowMs
        const registeredInWindow = registered >= NOW - windowMs && registered <= NOW
        return signedIn || (registeredInWindow && user.Events === 0)
    })
        .filter(user => user.Events > 0 || periodDays >= 1)
        .filter(user => match(user, search, ['Name', 'Email', 'CompanyName']))
        .filter(user => user.Events > 0)
        .map(user => ({ ...user, Events: Math.max(1, scaled(user.Events, periodDays)) }))
    const signed = rows
    const events = signed.reduce((sum, user) => sum + user.Events, 0)
    const regs = SIGNINS.filter(user => {
        const registered = Date.parse(`${user.RegisteredOn}T12:00:00Z`)
        return registered >= NOW - periodDays * 86400000 && registered <= NOW
    }).length
    return {
        ...pageOf(signed, pageNumber, pageSize),
        UniqueUsers: signed.length,
        Events: events,
        NewRegistrations: regs,
        UnlicensedSignedIn: signed.filter(user => user.License !== 'Paid').length,
    }
}

export const sampleWatchlist = ({ breach, pageNumber, pageSize, search }) => {
    const base = WATCH.filter(user => user.License !== 'Paid' && (user.Templates >= 3 || user.Team >= 2))
    const rows = base
        .filter(user => breach === 'All' || user.Breach === breach)
        .filter(user => match(user, search, ['Name', 'Email', 'CompanyName']))
    return {
        ...pageOf(rows, pageNumber, pageSize),
        Flagged: base.length,
        TemplateThreshold: base.filter(user => user.Templates >= 3).length,
        TeamThreshold: base.filter(user => user.Team >= 2).length,
        Both: base.filter(user => user.Breach === 'Both').length,
    }
}

export const isMissingApi = error => !error?.status || error.status === 404
